import type { AdminTicket, TicketStatus } from "../types";

export type TicketColumns = Record<TicketStatus, AdminTicket[]>;

export function moveTicketBetweenColumns(columns: TicketColumns, ticket: AdminTicket, status: TicketStatus, updatedAt: string, beforeTicketId?: string | null): TicketColumns {
  const withoutTicket: TicketColumns = {
    inbox: columns.inbox.filter((entry) => entry.id !== ticket.id),
    todo: columns.todo.filter((entry) => entry.id !== ticket.id),
    in_progress: columns.in_progress.filter((entry) => entry.id !== ticket.id),
    done: columns.done.filter((entry) => entry.id !== ticket.id)
  };
  const destination = [...withoutTicket[status]];
  const insertionIndex = beforeTicketId === null
    ? destination.length
    : beforeTicketId
      ? Math.max(0, destination.findIndex((entry) => entry.id === beforeTicketId))
      : 0;
  destination.splice(insertionIndex, 0, { ...ticket, status, updatedAt, rank: (insertionIndex + 1) * 1024 });
  return { ...withoutTicket, [status]: destination.map((entry, index) => ({ ...entry, rank: (index + 1) * 1024 })) };
}
